import { RolexContainer } from './Container'
import { Button } from '@components/rolex-ui/Button'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type RolexTextBlockProps = {
  className?: string
  description: string
  title?: string
  buttonLink?: string
  buttonTitle?: string
  headingTag?: string
  displayRolexPlaque?: boolean
}

export const RolexTextBlock: FC<RolexTextBlockProps> = ({
  title,
  description,
  buttonLink,
  buttonTitle,
  headingTag,
  className,
  displayRolexPlaque = false,
}) => {
  const {
    i18n: { language },
  } = useTranslation()
  const plaqueSrc = language === 'nl' ? '/images/rolex-plaque.jpeg' : '/images/rolex-plaque-en.jpeg'
  const hasButton = buttonLink && buttonTitle
  let applicableTag = 'h1'

  if (headingTag === 'h2') {
    applicableTag = 'h2'
  }

  if (headingTag === 'h3') {
    applicableTag = 'h3'
  }

  if (headingTag === 'h4') {
    applicableTag = 'h4'
  }

  return (
    <RolexContainer
      className={cn(
        `mb-[60px] grid w-full grid-cols-6 gap-2 md:grid-cols-12 lg:mb-[90px]`,
        className,
      )}
    >
      <div className="col-span-6 flex flex-col items-start md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
        {displayRolexPlaque && (
          <img
            src={plaqueSrc}
            alt="rolex plaque"
            style={{ maxWidth: '7rem', marginBottom: '1rem' }}
          />
        )}
        {title && (
          <Heading
            variant="headline50"
            className="mb-4 whitespace-pre-line"
            as={applicableTag as any}
          >
            {title}
          </Heading>
        )}
        <Text variant="body20" weight="light">
          {description}
        </Text>
        {hasButton && (
          <Button as="link" href={buttonLink} variant="primary" className="mt-8">
            {buttonTitle}
          </Button>
        )}
      </div>
    </RolexContainer>
  )
}
